// Date helpers shared by the AppointmentConfirm page subcomponents.

export const ES_WEEKDAYS = ["dom", "lun", "mar", "mié", "jue", "vie", "sáb"];
export const ES_MONTHS = [
  "ene", "feb", "mar", "abr", "may", "jun",
  "jul", "ago", "sep", "oct", "nov", "dic",
];

export function parseDt(s) {
  if (!s) return null;
  const cleaned = s.replace(" ", "T").slice(0, 19);
  const d = new Date(cleaned);
  return isNaN(d.getTime()) ? null : d;
}

/** Returns the busy slot that overlaps with the proposed new datetime, or null. */
export function conflictsWith(newDateIso, durationMin, busy) {
  const ns = parseDt(newDateIso);
  if (!ns) return null;
  const ne = new Date(ns.getTime() + (Number(durationMin) || 30) * 60000);
  for (const b of busy || []) {
    const bs = parseDt(b.date);
    if (!bs) continue;
    const be = new Date(bs.getTime() + (Number(b.duration_min) || 30) * 60000);
    if (ns < be && ne > bs) return b;
  }
  return null;
}

export function fmtChip(iso) {
  const d = parseDt(iso);
  if (!d) return iso;
  const wd = ES_WEEKDAYS[d.getDay()];
  const time = `${String(d.getHours()).padStart(2, "0")}:${String(d.getMinutes()).padStart(2, "0")}`;
  return `${wd} ${d.getDate()} ${ES_MONTHS[d.getMonth()]} · ${time}`;
}
